import { render, staticRenderFns } from "./BdAdd.vue?vue&type=template&id=5dba7579&"
import script from "./BdAdd.vue?vue&type=script&lang=js&"
export * from "./BdAdd.vue?vue&type=script&lang=js&"
import style0 from "./BdAdd.vue?vue&type=style&index=0&id=5dba7579&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports